


enum UserEventType {
    REGISTER="REGISTER",
    LOGIN="LOGIN",
    DEPOSIT="DEPOSIT",
    WITHDRAW_REQUESTED="WITHDRAW_REQUESTED",
    WITHDRAW_APPROVED="WITHDRAW_APPROVED"
}
export interface UserEvent {
    type : UserEventType;
    userUid : string;
}

export interface UserWithdrawEvent extends UserEvent {
    amount? : Number;
    currency? : string;
    amountEur? : Number;
    provider? : string;
    paymentUid? : string;
}

export interface UserDepositEvent extends UserWithdrawEvent {
    firstDeposit? : boolean;
}

const parseAmount = (amount?: string) => {
    if(!amount) {
        return 0;
    }
    try {
        return parseFloat(amount);
    } catch (e) {
        return 0;
    }
}

const postUserEvent = (evt : UserEvent) => {
    window.postMessage(evt, "*");
}

export const onUserRegistered = (userUid : string)  => {
    postUserEvent({
        type : UserEventType.REGISTER,
        userUid : userUid
    })
}

export const onUserLogin = (userUid : string)  => {
    postUserEvent({
        type : UserEventType.LOGIN,
        userUid : userUid
    })
}
export const onUserDeposit = (userUid : string, amount? : string, currency? : string, amountEur?: string, firstDeposit?: string, provider?: string, paymentUid? : string)  => {
    const depositEvent : UserDepositEvent = {
        type : UserEventType.DEPOSIT,
        userUid : userUid,
        amount : parseAmount(amount),
        currency : currency,
        amountEur : parseAmount(amountEur),
        firstDeposit : firstDeposit == "true",
        provider : provider,
        paymentUid : paymentUid
    }
    postUserEvent(depositEvent);
}

export const onUserWithdrawRequested = (userUid : string, amount? : string, currency? : string, provider?: string, paymentUid? : string)  => {
    const depositEvent : UserWithdrawEvent = {
        type : UserEventType.WITHDRAW_REQUESTED,
        userUid : userUid,
        amount : parseAmount(amount),
        currency : currency,
        provider : provider,
        paymentUid : paymentUid
    }
    postUserEvent(depositEvent);
}
export const onUserWithdrawApproved = (userUid : string, amount? : string, currency? : string, amountEur?: string, provider?: string, paymentUid? : string)  => {
    const depositEvent : UserWithdrawEvent = {
        type : UserEventType.WITHDRAW_APPROVED,
        userUid : userUid,
        amount : parseAmount(amount),
        currency : currency,
        amountEur : parseAmount(amountEur),
        provider : provider,
        paymentUid : paymentUid
    }
    postUserEvent(depositEvent);
}